module.exports = __webpack_public_path__ + "media/preview/all_hands@1x-31c62209.png";